var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333344 6.99992C0.333344 3.31792 3.31801 0.333252 7.00001 0.333252C10.682 0.333252 13.6667 3.31792 13.6667 6.99992C13.6667 10.6819 10.682 13.6666 7.00001 13.6666C3.31801 13.6666 0.333344 10.6819 0.333344 6.99992ZM7.66668 3.66659C7.66668 3.48977 7.59644 3.32021 7.47141 3.19518C7.34639 3.07016 7.17682 2.99992 7.00001 2.99992C6.8232 2.99992 6.65363 3.07016 6.52861 3.19518C6.40358 3.32021 6.33334 3.48977 6.33334 3.66659V6.17592C6.33336 6.54729 6.43677 6.91131 6.63199 7.22723C6.82721 7.54314 7.10654 7.79846 7.43868 7.96459L9.36868 8.92925C9.44726 8.97163 9.53356 8.99779 9.62244 9.00618C9.71133 9.01457 9.801 9.00502 9.88612 8.9781C9.97125 8.95118 10.0501 8.90744 10.118 8.84946C10.1859 8.79149 10.2415 8.72046 10.2814 8.64061C10.3213 8.56075 10.3448 8.47369 10.3504 8.38459C10.3561 8.29548 10.3438 8.20615 10.3142 8.1219C10.2847 8.03764 10.2385 7.96018 10.1785 7.89411C10.1184 7.82803 10.0457 7.77469 9.96468 7.73725L8.03534 6.77192C7.92462 6.71659 7.83149 6.63153 7.76638 6.52627C7.70127 6.42101 7.66674 6.29969 7.66668 6.17592V3.66659Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.133bec1a74ecf4596c1942eb3507e4e7.svg";
export { ForwardRef as ReactComponent };